<template>
  <el-main class="layout-main">
    <el-scrollbar class="layout-scrollbar" :style="{ minHeight: headerHeight }">
      <!-- 对齐 EB layout/routerView/parent.vue：内容区透出 layout-main 灰底 #F0F2F5，勿包 layout-view-bg-white -->
      <section class="layout-parent">
        <router-view v-slot="{ Component, route: r }">
          <transition :name="pageTransition" mode="out-in">
            <keep-alive :include="cachedViews">
              <component :is="Component" v-if="!r.meta?.link" :key="r.path" />
            </keep-alive>
          </transition>
        </router-view>
      </section>
      <crmeb-footer />
    </el-scrollbar>
  </el-main>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import useTagsViewStore from '@/store/modules/tagsView';
import CrmebFooter from '../footer/CrmebFooter.vue';

const themeStore = useCrmebThemeConfigStore();
const tagsViewStore = useTagsViewStore();

const headerHeight = computed(() =>
  themeStore.themeConfig.isTagsview ? 'calc(100vh - 84px)' : 'calc(100vh - 50px)',
);

const pageTransition = computed(() => {
  const name = themeStore.themeConfig.animation;
  if (name === 'slide-left' || name === 'slide-right' || name === 'opacitys') {
    return name;
  }
  return 'fade-transform';
});

const cachedViews = computed(() => tagsViewStore.cachedViews as string[]);
</script>

<style scoped lang="scss">
.layout-parent {
  min-height: 100%;
}
</style>
